import { CURRENCY_LIST } from 'core/constants/CurrenciesConstants';
import { TFunction } from 'i18next';
import { localiseCurrency } from './localization';

export const calculateSalesPercentageChange = (directSales: number, recoveredSales: number): number => {
  const totalSales = directSales + recoveredSales;

  if (totalSales <= directSales) {
    return 0;
  }

  return (recoveredSales / totalSales) * 100;
};

export function formatComparisonCurrency(value: number, baseCurrency: CURRENCY_LIST, t: TFunction) {
  return `${t('key.comparison')}: ${localiseCurrency(value, baseCurrency)}`;
}

export function formatComparisonRate(value: number, t: TFunction, showSign = false) {
  return `${t('key.comparison')}: ${formatRate(value, showSign)}`;
}

const minimumNonZeroValue = 0.1;
export function formatRate(rate: number, showSign = false): string {
  const sign = showSign ? (rate > 0 ? '+' : rate < 0 ? '-' : '') : '';

  if (!rate || Math.abs(rate) < minimumNonZeroValue) {
    return '0%';
  }

  return `${sign}${rate.toFixed(1)}%`;
}
